// Öffentliche Webseiten/Dienste — einzige Quelle für die Home-Kugel
// (ServiceGlobe) und die Chip-Liste (Services). Neue Seite = neuer Eintrag hier.
// `color` ist ein Vuetify-Farbname (siehe vuetify/lib/util/colors).
export default [
  {
    host: "rtmp.reckhaus.it",
    url: "https://rtmp.reckhaus.it",
    icon: "mdi-video-wireless",
    color: "red",
  },
  {
    host: "sia-leitstelle.de",
    url: "https://sia-leitstelle.de",
    icon: "mdi-shield-alert",
    color: "orange",
  },
  {
    host: "streitix.reckhaus.it",
    url: "https://streitix.reckhaus.it",
    icon: "mdi-scale-balance",
    color: "purple",
  },
  {
    host: "seafile.reckhaus.it",
    url: "https://seafile.reckhaus.it",
    icon: "mdi-folder-sync",
    color: "cyan",
  },
  {
    host: "png.reckhaus.it",
    url: "https://png.reckhaus.it",
    icon: "mdi-image",
    color: "green",
  },
  {
    host: "qr.reckhaus.it",
    url: "https://qr.reckhaus.it",
    icon: "mdi-qrcode",
    color: "blue",
  },
  {
    host: "keygen.reckhaus.it",
    url: "https://keygen.reckhaus.it",
    icon: "mdi-key-variant",
    color: "amber",
  },
]
